module.exports = __webpack_public_path__ + "static/media/YF86_09.1321480f.jpg";